import { configureStore } from '@reduxjs/toolkit';
import { rootEpic, rootReducer } from './root';

import { createEpicMiddleware } from 'redux-observable';
const epicMiddleware = createEpicMiddleware();

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false
		}).concat(epicMiddleware)
});

epicMiddleware.run(rootEpic);

export default store;
